import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import ISEElement1 from './ise-elements/ISEElement1';
import ISEElement2 from './ise-elements/ISEElement2';
import ISEElement3 from './ise-elements/ISEElement3';
import ISEElement4 from './ise-elements/ISEElement4';
import ISEElement5 from './ise-elements/ISEElement5';
import ISEElement6 from './ise-elements/ISEElement6';
import ISEElement7 from './ise-elements/ISEElement7';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ISEElement = () => {
  const { elementId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(false);
  const [verifying, setVerifying] = useState(true);
  const token = searchParams.get('token') || localStorage.getItem('ise_access_token');

  useEffect(() => {
    const verifyAccess = async () => {
      if (!token) {
        navigate('/books/ise-interactive');
        return;
      }
      try {
        const response = await fetch(`${API_URL}/api/books/ise-interactive/verify-access?token=${token}`);
        const data = await response.json();
        if (data.valid) {
          setHasAccess(true);
          localStorage.setItem('ise_access_token', token);
        } else {
          navigate('/books/ise-interactive');
        }
      } catch (error) {
        console.error('Error verifying access:', error);
        navigate('/books/ise-interactive');
      } finally {
        setVerifying(false);
      }
    };
    verifyAccess();
  }, [token, navigate]);

  if (verifying) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ffffff' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', color: '#111827', marginBottom: '16px' }}>Verifying access...</div>
        </div>
      </div>
    );
  }

  if (!hasAccess) return null;

  const elementComponents = {
    'element-1': ISEElement1,
    'element-2': ISEElement2,
    'element-3': ISEElement3,
    'element-4': ISEElement4,
    'element-5': ISEElement5,
    'element-6': ISEElement6,
    'element-7': ISEElement7,
  };

  const ElementComponent = elementComponents[elementId];

  if (!ElementComponent) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ffffff' }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ color: '#111827', fontSize: '32px', marginBottom: '16px' }}>Element Not Found</h1>
          <button onClick={() => navigate('/books/ise-interactive')} style={{ padding: '12px 24px', background: '#f97316', color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' }}>
            Back to ISE Study Guide
          </button>
        </div>
      </div>
    );
  }

  return <ElementComponent />;
};

export default ISEElement;